import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgDelete = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 25 25"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M8.464 3.84h-.22a.22.22 0 0 0 .22-.22v.22h8.36v-.22c0 .12.1.22.22.22h-.22v1.98h1.98v-2.2c0-.971-.789-1.76-1.76-1.76h-8.8c-.97 0-1.76.789-1.76 1.76v2.2h1.98V3.84Zm13.86 1.98H2.964a.88.88 0 0 0-.88.88v.88c0 .12.1.22.22.22h1.661l.68 14.382c.044.938.82 1.677 1.757 1.677h12.485c.94 0 1.713-.737 1.757-1.677l.68-14.383h1.66a.22.22 0 0 0 .22-.22V6.7a.88.88 0 0 0-.88-.88Zm-3.649 16.06H6.614L5.948 7.8h13.393l-.666 14.08Z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
)

const ForwardRef = forwardRef(SvgDelete)
const Memo = memo(ForwardRef)
export default Memo
